module.exports = __webpack_public_path__ + "static/media/LogoMaruStd-Ultra.2221784b.svg";